const isRadio = type => type === 'radio';

export default isRadio;
